import { useState, useEffect } from 'react';
import './Press.css';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

import sommelierPdf from '../../assets/pdfs/Sommelier Magazin.pdf';
import falstaffPdf from '../../assets/pdfs/Falstaff WineBarGuide.pdf';
import monGuerlainPdf from '../../assets/pdfs/Mon_guerlan.pdf';
import patisseriePdf from '../../assets/pdfs/Patisserie-Anzeige.pdf';
import ueberUnsPdf from '../../assets/pdfs/UeberUns.pdf';
import cateringPdf from '../../assets/pdfs/Presentation_Catering.pdf';

import falstaffBarguide2027 from '../../assets/auszeichnungen/Falstaff_2027_Barguide.jpeg';
import falstaffBarguide from '../../assets/auszeichnungen/Falstaff_2026_Barguide.png';
import falstaffBistro from '../../assets/auszeichnungen/Falstaff_2026_BistrodesJahres.png';
import starwinelist2023 from '../../assets/auszeichnungen/Starwinelist_2023.png';
import starwinelist2025 from '../../assets/auszeichnungen/Starwinelist_2025.png';
import ihkAusland from '../../assets/auszeichnungen/ihk_ausland.png';
import kammersiegerin from '../../assets/auszeichnungen/Urkunde_Kammersiegerin.jpeg';
import ehrenurkunde from '../../assets/auszeichnungen/Ehrenurkunde.jpeg';
import gaultMillau24 from '../../assets/auszeichnungen/Gault_Millau_24.jpg';
import gaultMillau20 from '../../assets/auszeichnungen/Gault_Millau_20.jpg';
import feinschmecker23 from '../../assets/auszeichnungen/Feinschmecker_23.jpg';

pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const awards = [
  { id: 1, src: falstaffBarguide2027, alt: 'Falstaff Bar Guide 2027 – 95 Punkte' },
  { id: 2, src: falstaffBarguide,  alt: 'Falstaff Bar Guide 2026' },
  { id: 3, src: falstaffBistro,    alt: 'Falstaff Bistro des Jahres 2026' },
  { id: 4, src: starwinelist2023,  alt: 'Star Wine List 2023' },
  { id: 5, src: starwinelist2025,  alt: 'Star Wine List 2025' },
  { id: 6, src: ihkAusland,        alt: 'IHK Auszeichnung' },
  { id: 7, src: kammersiegerin,    alt: 'Kammersiegerin 2023' },
  { id: 8, src: ehrenurkunde,      alt: 'Ehrenurkunde Meisterprüfung' },
  { id: 9, src: gaultMillau24,     alt: 'Gault&Millau – Best International Wine List 2023/24' },
  { id: 10, src: gaultMillau20,    alt: 'Gault&Millau 2020 – 14 Punkte' },
  { id: 11, src: feinschmecker23,  alt: 'Der Feinschmecker – Bestes Restaurant für jeden Tag 2023' },
];

const pressItems = [
  { id: 1, title: 'Über uns',               pdf: ueberUnsPdf },
  { id: 2, title: 'Falstaff Wine Bar Guide', pdf: falstaffPdf },
  { id: 3, title: 'Sommelier Magazin',       pdf: sommelierPdf },
  { id: 4, title: 'Patisserie-Anzeige',     pdf: patisseriePdf },
  { id: 5, title: 'Mon Guerlain',           pdf: monGuerlainPdf },
  { id: 6, title: 'Catering Präsentation', pdf: cateringPdf },
];

function Press() {
  const [lightbox, setLightbox] = useState(null);

  useEffect(() => {
    if (!lightbox) return;
    const onKey = (e) => { if (e.key === 'Escape') setLightbox(null); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [lightbox]);

  return (
    <section id="press" className="press">
      <div className="press__inner">

        <div className="press__header">
          <span className="press__label">Presse &amp; Medien</span>
          <h2 className="press__title">Auszeichnungen &amp; Veröffentlichungen</h2>
          <div className="press__divider" />
        </div>

        {/* Auszeichnungen – Fokus */}
        <div className="press__awards">
          {awards.map((award) => (
            <button
              key={award.id}
              className="press__award-item"
              onClick={() => setLightbox(award)}
              aria-label={award.alt}
            >
              <img src={award.src} alt={award.alt} className="press__award-img" />
              <span className="press__award-caption">{award.alt}</span>
            </button>
          ))}
        </div>

        {/* PDFs – sekundär */}
        <div className="press__publications">
          <span className="press__publications-label">Veröffentlichungen</span>
          <div className="press__grid">
            {pressItems.map((item) => (
              <a
                key={item.id}
                href={item.pdf}
                target="_blank"
                rel="noopener noreferrer"
                className="press__card"
              >
                <div className="press__thumb-wrap">
                  <Document file={item.pdf} loading={<div className="press__loading" />}>
                    <Page
                      pageNumber={1}
                      renderTextLayer={false}
                      renderAnnotationLayer={false}
                      width={300}
                    />
                  </Document>
                  <div className="press__overlay">
                    <span className="press__overlay-icon">↗</span>
                  </div>
                </div>
                <span className="press__card-title">{item.title}</span>
              </a>
            ))}
          </div>
        </div>

      </div>

      {/* Lightbox */}
      {lightbox && (
        <div className="press__lightbox" onClick={() => setLightbox(null)}>
          <div className="press__lightbox-content" onClick={(e) => e.stopPropagation()}>
            <button className="press__lightbox-close" onClick={() => setLightbox(null)} aria-label="Schließen">✕</button>
            <img src={lightbox.src} alt={lightbox.alt} className="press__lightbox-img" />
            <span className="press__lightbox-caption">{lightbox.alt}</span>
          </div>
        </div>
      )}
    </section>
  );
}

export default Press;
